/*
 * Иконки оболочки редактора — inline SVG, без эмодзи и без картинок.
 *
 * Единый штрих 1.8 и viewBox 24 — чтобы в меню они выглядели одним набором.
 * Цвет наследуется от текста (currentColor), поэтому активный пункт красится
 * вместе с иконкой.
 */
import React from 'react';

const base = (size) => ({
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
});

/** Куб-логотип: изометрия, как на иконке вкладки. */
export function IconCube({ size = 24, color }) {
    return (
        <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
            <path d="M32 8 L54 20 L32 32 L10 20 Z" fill="#00d4ff" />
            <path d="M10 20 L32 32 L32 56 L10 44 Z" fill="#0090b0" />
            <path d="M54 20 L54 44 L32 56 L32 32 Z" fill="#006c86" />
            <path
                d="M32 8 L54 20 L32 32 L10 20 Z M10 20 L10 44 L32 56 L54 44 L54 20 M32 32 L32 56"
                fill="none" stroke={color || '#e8fbff'} strokeWidth="2.4" strokeLinejoin="round"
            />
        </svg>
    );
}

/** Папка — «Мои проекты». */
export function IconFolder({ size = 20, color }) {
    return (
        <svg {...base(size)} style={color ? { color } : undefined} aria-hidden="true">
            <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
        </svg>
    );
}

/** Глобус — «Лента сообщества». */
export function IconFeed({ size = 20, color }) {
    return (
        <svg {...base(size)} style={color ? { color } : undefined} aria-hidden="true">
            <circle cx="12" cy="12" r="9" />
            <path d="M3 12h18M12 3c2.5 2.7 2.5 15.3 0 18M12 3c-2.5 2.7-2.5 15.3 0 18" />
        </svg>
    );
}

/** Книга — «Курсы». */
export function IconBook({ size = 20, color }) {
    return (
        <svg {...base(size)} style={color ? { color } : undefined} aria-hidden="true">
            <path d="M4 5.5A1.5 1.5 0 0 1 5.5 4H10a2 2 0 0 1 2 2v13a2 2 0 0 0-2-2H5.5A1.5 1.5 0 0 1 4 15.5z" />
            <path d="M20 5.5A1.5 1.5 0 0 0 18.5 4H14a2 2 0 0 0-2 2v13a2 2 0 0 1 2-2h4.5a1.5 1.5 0 0 0 1.5-1.5z" />
        </svg>
    );
}

/** Стрелка влево — возврат в школу. */
export function IconBack({ size = 20, color }) {
    return (
        <svg {...base(size)} style={color ? { color } : undefined} aria-hidden="true">
            <path d="M19 12H5M11 18l-6-6 6-6" />
        </svg>
    );
}

/** Шеврон для сворачивания меню; flip разворачивает его. */
export function IconCollapse({ size = 18, flip = false, color }) {
    return (
        <svg
            {...base(size)}
            style={{ ...(color ? { color } : {}), transform: flip ? 'rotate(180deg)' : undefined }}
            aria-hidden="true"
        >
            <path d="M15 18l-6-6 6-6" />
        </svg>
    );
}
